'use strict';

var appDom = require('./app-dom');
var favorites = require('./favorites');
var favoritesIconHelper = require('./favorites-icon-helper');
var dataMgr = require('./data-mgr');

var toggleFavoriteIcon = function(metaData) {

	var isFavorite = favorites.isFavorite(metaData.photoId);

	favoritesIconHelper.toggleClass(appDom.slideshowImageMetaFavoriteBtn, isFavorite);
	favoritesIconHelper.toggleToolTip(appDom.slideshowImageMetaFavoriteBtn, isFavorite);

};

var hasUserDisabledAllMetaFunctionality = function() {

	return !dataMgr.hasFavoritesEnabled() &&
		   !dataMgr.hasDownloadsEnabled() &&
		   !dataMgr.hasSharingEnabled() &&
		   !dataMgr.hasFileNamesEnabled() &&
		   !dataMgr.hasCommentsEnabled() &&
		   !dataMgr.hasEcommerceEnabled();

};

var populate = function(metaData) {

	var hasCaption = metaData.title.length > 0;

	if (hasUserDisabledAllMetaFunctionality() && !hasCaption) {

		appDom.slideshowImageMeta.addClass('slideshow__image-meta--is-hidden');

	}

	else {

		appDom.slideshowImageMeta.removeClass('slideshow__image-meta--is-hidden');

		appDom.slideshowImageMetaCaption.html(metaData.title);
		appDom.slideshowImageMetaName.html(metaData.description);
		toggleFavoriteIcon(metaData);

	}

};

module.exports = {

	populate: populate,
	toggleFavoriteIcon: toggleFavoriteIcon

};
